<template>
  <div>
    <app-warp :title='pageSet.home&&pageSet.home.params.title' >
      <template #app-content>
        <div style="min-height:100%;background-size:100% 100%;"  class="moduleMain">
          <template v-for="(item,key) in pageSet" :key="key">
            <div @click.stop="selectModule(key)" v-if="activeKey==key">
              <component :is="key" :data="item" />
            </div>
          </template>
        </div>
      </template>
      <template #app-sider>
        <a-radio-group v-model:value="activeKey" button-style="solid" @change="changePage" class="m-b-20 m-l-20">
          <a-radio-button value="home">基本配置</a-radio-button>
          <a-radio-button value="standard">百分标准</a-radio-button>
          <a-radio-button value="ly">百分乐友</a-radio-button>
          <!-- <a-radio-button value="pzjk">品质监控</a-radio-button> -->
        </a-radio-group>
        <div class="moduleContent " style="width:100%;margin-left:20px">
          <a-form :model="form" ref='ruleForm' :label-col="{span:4}" :wrapper-col="{span:18}">
            <template v-for="(value,index) in formCreateData" :key="index+value.type+new Date()">
              <a-form-item :label="value.label" :help="value.help">
                <!-- 普通表单 -->
                <template v-if="value.stamp=='input'">
                  <a-row :gutter="16">
                    <a-col :span="10">
                      <a-input v-model:value="modelRef[value.key][value.name]" :type="value.type" :help="value.help" :maxlength="value.maxLength || 9999" />
                    </a-col>
                    <a-col :span="12" v-if="value.defaultValue">
                      <a href="javascript:;" @click="modelRef[value.key][value.name]=value.defaultValue">恢复默认设置</a>
                    </a-col>
                  </a-row>
                </template>
                <template v-if="value.stamp=='query'">
                  <a-input-search style="width:200px" v-model:value="modelRef[value.key][value.name]" @search="childrenIndex=indexs;fwVisible=true" readonly placeholder="默认模板">
                    <template #enterButton>
                      <a-button type="primary">
                        选择
                      </a-button>
                    </template>
                  </a-input-search>
                </template>

                <!-- 选择框 -->
                <template v-if="value.stamp=='select'">
                  <a-select v-model:value="modelRef[value.key][value.name]" :style="{width:'270px'}" placeholder="请选择">
                    <a-select-option v-for='item in value.options' :key='item.value' :value="item.value">{{item.label}}
                    </a-select-option>
                  </a-select>
                </template>
                <template v-if="value.stamp=='singleImage'">
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <material :groupType='1' :image="modelRef[value.key][value.name]" :max="1" v-on:handlechoose="(data)=>{
                    modelRef[value.key][value.name]=data}" v-on:handledel="modelRef[value.key][value.name]=''" />
                    </a-col>
                    <a-col :span="12" v-if="value.defaultValue">
                      <a href="javascript:;" v-if="value.defaultValue" @click="modelRef[value.key][value.name]=value.defaultValue">恢复默认图</a>
                    </a-col>
                  </a-row>
                </template>
                <!-- 单选框 -->
                <template v-if="value.stamp=='radio'">
                  <a-radio-group :options="value.options" v-model:value="modelRef[value.key][value.name]" />
                </template>
                      <!-- 图片上传 -->
                <template v-if="value.stamp=='image'">
                  <div v-for="(items,indexs) in modelRef.data" :key="indexs" class="imagesContent">
                    <a-form-item label="图片" :label-col="{span:4}" :wrapper-col="{span:17}">
                      <material :groupType='1' :image="items['imgUrl']" :max="1" v-on:handlechoose="(data)=>{items['imgUrl']=info.picdomain+data}" v-on:handledel="items['imgUrl']=''" />
                    </a-form-item>
                    <CloseOutlined class="images_del" @click="delImagesData(indexs)" />
                  </div>
                  <a-button type="primary" @click="addImagesData(index)" >
                    添加一个
                  </a-button>
                </template>
              </a-form-item>
            </template>
          </a-form>
        </div>
      </template>
    </app-warp>
    <!-- 关联模板 -->
    <a-modal :keyboard="false" title="关联模板" centered v-model:visible="fwVisible" @ok="fwVisible=false" style="width:1200px" :width="1200">
      <fwAudiSelect v-on:select="selecFwAudi" />
    </a-modal>
  </div>
</template>

<script>
import standard from "./components/standard.vue";
import ly from "./components/ly.vue";
import home from "./components/home.vue";
import pzjk from "./components/pzjk.vue";
import config from "@/config";
import forms from "./form";
import * as Icon from "@ant-design/icons-vue";
import { onMounted, reactive, ref, toRefs, watch, watchEffect } from "vue";
import { message } from 'ant-design-vue';
import store from '@/store'
import {getCanvas} from '@/libs/html2canvas'
export default {
  components: {
    standard,
    ly,
    home,
    pzjk,
    ...Icon,
  },
  name: "c_10000010_1",
  props: {
    template_data: Object,
  },
  setup(props, { emit }) {
    // 模板页当前页面 记录
    const state = reactive({
      active: "home",
      fwVisible: false,
    });
    const activeKey = ref("home");
    var pageSet = ref({
        home: {
          style: {
            icon: ""
          },
          params:{
            title:"首页",
            antis_fake_tem_title:"",
            antis_fake_tem_id:"",
            video_url:"",
            sglink:"",
            phone:""
          }
        },
        standard: {
          style: {
            backgroundColor:'#abdeff'
          },
          params:{
            tips:"领取成功"
          },
          data:[{ imgUrl: config.oss[process.env.VUE_APP_type] +"/web_base_assets/scan/customer_10000010/banner.png", linkUrl: "" }]
        },
        ly: {
          style: {
            icon:config.oss[process.env.VUE_APP_type] +"/web_base_assets/scan/customer_10000010/map.png",
            textColor:'#2182CA',
            backgroundColor:"#F8F8F8"
          },
          params:{
            tips:"会员卡已被领取",
            number:null,
          }
        },
        pzjk: {
          data:[{ imgUrl: config.oss[process.env.VUE_APP_type] +"/web_base_assets/scan/customer_10000010/banner.png", linkUrl: "" }]
        }
    });
    watchEffect(() => {
      if (JSON.stringify(props.template_data) != "{}") {
        pageSet.value = props.template_data;
      }
    });

    var modelRef = ref();
    const moduleIndex = ref(0);
    // 读取模块表单数据
    var formCreateData = ref({});
    const formCreate = () => {
      forms.forEach((element) => {
        if (element.type == state.active) {
          formCreateData.value = element.formItems;
        }
      });
      console.log(formCreateData.value);
    };
    // 模块
    const selectModule = (type) => {
      modelRef.value = pageSet.value[type];
      state.active = type;
      formCreate();
    };
    const initData = () => {
      formCreate();
    };
    const oss = config.oss[process.env.VUE_APP_type];
    onMounted(() => {
      selectModule(activeKey.value);
      initData();
    });
    const submit = () => {
      emit("submit", pageSet.value);
      return pageSet.value;
    };
        const getThumb = () => {
          // 选中首页 用于截图
        return new Promise((resolve,reject)=>{
            // 选中首页 用于截图
          activeKey.value='home'
          var element= document.getElementById('app-subject')
          getCanvas(element).then(res=>{
              resolve(res.image)
          }).catch(()=>{
              reject('/web_base_assets/scan/customer_10000010/template.jpg')
          })
      })
      // return "";
    };

    const changePage = (e) => {
      state.value = e.target.value;
      selectModule(activeKey.value);
      formCreate();
    };
    const selecFwAudi = (data) => {
      pageSet.value["home"].params.antis_fake_tem_id = data.id;
      pageSet.value["home"].params.antis_fake_tem_title = data.name;
      state.fwVisible = false;
    };
        // 删除轮播图片数据
    const delImagesData = (index) => {
      if (modelRef.value.data.length == 1) {
        message.error("至少要存在一个元素");
      } else {
        modelRef.value.data.splice(index, 1);
      }
    };
    // 追加图片数据
    const addImagesData = (index) => {
      if( modelRef.value.data.length==5){
        return
      }
      modelRef.value.data.push({ imgUrl: "", linkUrl: "" });
    };
    return {
      activeKey,
      pageSet,
      selectModule,
      formCreateData,
      ...toRefs(state),
      modelRef,
      moduleIndex,
      oss,
      submit,
      getThumb,
      changePage,
      delImagesData,
      addImagesData,
      selecFwAudi,
            info: store.state.user.info,
    };
  },
};
</script>
<style lang="less" scoped>
@import url("../../module.less");
.imagesContent {
  padding: 20px;
  background: #f7fafc;
  position: relative;
  border-radius: 3px;
  cursor: move;
 height: 180px;
  margin-bottom: 20px;
  .images_del {
    position: absolute;
    right: 10px;
    top: 0;
    cursor: pointer;
  }
}
</style>